import { IApiConfig } from "./interfaces/IApiConfig";

export const apiConfig: IApiConfig = {
    reportInappropriate: (): string => {
        throw new Error("You haven't set the reportInappropriate endpoint");
    },
    publicReportInappropriate: (): string => {
        throw new Error("You haven't set the publicReportInappropriate endpoint");
    }
};
